export const instagram = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.997 7.9983C9.79351 7.9983 7.99529 9.79651 7.99529 12C7.99529 14.2035 9.79351 16.0017 11.997 16.0017C14.2005 16.0017 15.9987 14.2035 15.9987 12C15.9987 9.79651 14.2005 7.9983 11.997 7.9983ZM23.9991 12C23.9991 10.3429 24.0141 8.70077 23.9211 7.04665C23.828 5.12536 23.3897 3.4202 21.9847 2.01525C20.5768 0.607302 18.8746 0.172008 16.9533 0.0789456C15.2962 -0.0141173 13.6541 0.000892936 12 0.000892936C10.3429 0.000892936 8.70077 -0.0141173 7.04665 0.0789456C5.12536 0.172008 3.4202 0.610305 2.01525 2.01525C0.607303 3.42321 0.172008 5.12536 0.0789456 7.04665C-0.0141172 8.70377 0.000892936 10.3459 0.000892936 12C0.000892936 13.6541 -0.0141172 15.2992 0.0789456 16.9533C0.172008 18.8746 0.610305 20.5798 2.01525 21.9847C3.42321 23.3927 5.12536 23.828 7.04665 23.9211C8.70377 24.0141 10.3459 23.9991 12 23.9991C13.6571 23.9991 15.2992 24.0141 16.9533 23.9211C18.8746 23.828 20.5798 23.3897 21.9847 21.9847C23.3927 20.5768 23.828 18.8746 23.9211 16.9533C24.0171 15.2992 23.9991 13.6571 23.9991 12ZM11.997 18.1572C8.58969 18.1572 5.83984 15.4073 5.83984 12C5.83984 8.5927 8.58969 5.84284 11.997 5.84284C15.4043 5.84284 18.1542 8.5927 18.1542 12C18.1542 15.4073 15.4043 18.1572 11.997 18.1572ZM18.4063 7.02864C17.6108 7.02864 16.9684 6.38621 16.9684 5.59067C16.9684 4.79513 17.6108 4.1527 18.4063 4.1527C19.2019 4.1527 19.8443 4.79513 19.8443 5.59067C19.8445 5.77957 19.8075 5.96667 19.7353 6.14124C19.6631 6.31581 19.5572 6.47442 19.4237 6.608C19.2901 6.74157 19.1315 6.84748 18.9569 6.91967C18.7823 6.99185 18.5952 7.02888 18.4063 7.02864Z"
      fill="currentColor"
    />
  </svg>
);

export const facebook = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.0405 0H0.960488C0.429488 0 0.000488281 0.429 0.000488281 0.96V23.04C0.000488281 23.571 0.429488 24 0.960488 24H23.0405C23.5715 24 24.0005 23.571 24.0005 23.04V0.96C24.0005 0.429 23.5715 0 23.0405 0ZM20.2685 7.005H18.3515C16.8485 7.005 16.5575 7.719 16.5575 8.769V11.082H20.1455L19.6775 14.703H16.5575V24H12.8165V14.706H9.68749V11.082H12.8165V8.412C12.8165 5.313 14.7095 3.624 17.4755 3.624C18.8015 3.624 19.9385 3.723 20.2715 3.768V7.005H20.2685Z"
      fill="currentColor"
    />
  </svg>
);

export const twitter = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0005 0C5.3737 0 0.000488281 5.37321 0.000488281 12C0.000488281 18.6268 5.3737 24 12.0005 24C18.6273 24 24.0005 18.6268 24.0005 12C24.0005 5.37321 18.6273 0 12.0005 0ZM17.7675 9.04554C17.7755 9.17143 17.7755 9.30268 17.7755 9.43125C17.7755 13.3634 14.7808 17.8929 9.30852 17.8929C7.62102 17.8929 6.05674 17.4027 4.73888 16.5589C4.97995 16.5857 5.21031 16.5964 5.45674 16.5964C6.8496 16.5964 8.12995 16.125 9.15049 15.3268C7.84335 15.3 6.74513 14.4429 6.37013 13.2643C6.82817 13.3313 7.24067 13.3313 7.7121 13.2107C7.03904 13.074 6.43408 12.7084 6 12.1762C5.56591 11.644 5.32947 10.9779 5.33085 10.2911V10.2536C5.7246 10.4759 6.18799 10.6125 6.67281 10.6313C6.26524 10.3596 5.931 9.99164 5.69971 9.5599C5.46843 9.12817 5.34725 8.64603 5.34692 8.15625C5.34692 7.60179 5.49156 7.09554 5.75138 6.65625C6.49844 7.5759 7.43066 8.32806 8.48745 8.86384C9.54423 9.39961 10.7019 9.70702 11.8853 9.76607C11.4648 7.74375 12.9755 6.10714 14.7916 6.10714C15.6487 6.10714 16.4201 6.46607 16.9639 7.04464C17.6362 6.91875 18.2791 6.66696 18.8523 6.32946C18.63 7.01786 18.1639 7.59911 17.5451 7.96607C18.1451 7.90179 18.7237 7.73571 19.2594 7.50268C18.855 8.09732 18.3487 8.625 17.7675 9.04554Z"
      fill="currentColor"
    />
  </svg>
);

export const linkedin = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.0405 0H0.960488C0.429488 0 0.000488281 0.429 0.000488281 0.96V23.04C0.000488281 23.571 0.429488 24 0.960488 24H23.0405C23.5715 24 24.0005 23.571 24.0005 23.04V0.96C24.0005 0.429 23.5715 0 23.0405 0ZM7.11949 20.451H3.55849V8.997H7.11949V20.451ZM5.34049 7.431C4.93227 7.431 4.53321 7.30995 4.19379 7.08315C3.85437 6.85636 3.58982 6.534 3.4336 6.15686C3.27738 5.77971 3.23651 5.36471 3.31615 4.96433C3.39579 4.56396 3.59236 4.19619 3.88102 3.90753C4.16968 3.61888 4.53745 3.4223 4.93782 3.34266C5.3382 3.26302 5.7532 3.30389 6.13035 3.46011C6.50749 3.61633 6.82985 3.88088 7.05664 4.2203C7.28344 4.55973 7.40449 4.95878 7.40449 5.367C7.40149 6.507 6.47749 7.431 5.34049 7.431ZM20.4515 20.451H16.8935V14.88C16.8935 13.551 16.8695 11.844 15.0425 11.844C13.1915 11.844 12.9065 13.29 12.9065 14.784V20.451H9.35149V8.997H12.7655V10.563H12.8135C13.2875 9.663 14.4485 8.712 16.1825 8.712C19.7885 8.712 20.4515 11.085 20.4515 14.169V20.451Z"
      fill="currentColor"
    />
  </svg>
);

export const pinterest = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fab"
    data-icon="pinterest-square"
    class="svg-inline--fa fa-pinterest-square fa-w-14"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
    ></path>
  </svg>
);

export const openNav = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 14.4263C20 15.0215 19.554 15.503 19.005 15.503H10.995C10.7311 15.503 10.478 15.3896 10.2914 15.1876C10.1048 14.9857 10 14.7119 10 14.4263C10 14.1407 10.1048 13.8669 10.2914 13.665C10.478 13.463 10.7311 13.3496 10.995 13.3496H19.005C19.555 13.3496 20 13.8311 20 14.4263Z"
      fill="currentColor"
    />
    <path
      d="M20 7.93217C20 8.52732 19.554 9.00886 19.005 9.00886H0.995C0.731109 9.00886 0.478028 8.89542 0.291429 8.6935C0.10483 8.49158 0 8.21772 0 7.93217C0 7.64661 0.10483 7.37275 0.291429 7.17083C0.478028 6.96891 0.731109 6.85547 0.995 6.85547H19.005C19.555 6.85547 20 7.33809 20 7.93217Z"
      fill="currentColor"
    />
    <path
      d="M19.005 2.51496C19.2689 2.51496 19.522 2.40152 19.7086 2.1996C19.8952 1.99768 20 1.72382 20 1.43826C20 1.15271 19.8952 0.878847 19.7086 0.676928C19.522 0.475009 19.2689 0.361572 19.005 0.361572H6.995C6.86433 0.361572 6.73495 0.389422 6.61423 0.443531C6.49351 0.497639 6.38382 0.576948 6.29143 0.676928C6.19903 0.776908 6.12574 0.895602 6.07574 1.02623C6.02574 1.15686 6 1.29687 6 1.43826C6 1.57966 6.02574 1.71967 6.07574 1.8503C6.12574 1.98093 6.19903 2.09962 6.29143 2.1996C6.38382 2.29958 6.49351 2.37889 6.61423 2.433C6.73495 2.48711 6.86433 2.51496 6.995 2.51496H19.005Z"
      fill="currentColor"
    />
  </svg>
);

export const closeNav = (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5092 0.773716C14.9179 1.16281 14.9416 1.8085 14.5636 2.21579L2.16395 15.5771C1.98226 15.7729 1.73012 15.8865 1.46297 15.8929C1.19583 15.8993 0.935568 15.7981 0.739453 15.6114C0.543338 15.4247 0.427429 15.1679 0.417225 14.8974C0.407022 14.627 0.503359 14.3651 0.685044 14.1693L13.0847 0.807987C13.4634 0.399951 14.1012 0.385331 14.5092 0.773716Z"
      fill="currentColor"
    />
    <path
      d="M0.878263 0.676685C1.2817 0.309194 1.90928 0.350271 2.27999 0.766833L14.4412 14.4322C14.6194 14.6325 14.7134 14.8945 14.7025 15.1608C14.6916 15.4271 14.5768 15.6757 14.3832 15.852C14.1896 16.0283 13.9332 16.1179 13.6703 16.101C13.4074 16.0841 13.1596 15.9621 12.9815 15.7619L0.820273 2.09648C0.448887 1.67916 0.475556 1.04351 0.878263 0.676685Z"
      fill="currentColor"
    />
  </svg>
);
